import React from 'react';
import FileUploaded from '~/components/FileUploaded';
import { PLACEHOLDER_IMAGE } from '~/config/constants';
import PropTypes from 'prop-types';
import PreviewAsBackground from '~/components/FileUploaded/picture-preview/PreviewAsBackground';

function FileUploadedWithResetCount({ pictureName, pictureVal, resetCount, formFileClass, previewComponent, id }) {
    const [tempUrl, setTempUrl] = React.useState(pictureVal);
    const pictureUrl = tempUrl || PLACEHOLDER_IMAGE;

    const inputEl = React.useRef(null);

    React.useEffect(() => {
        setTempUrl(pictureVal);
    }, [resetCount]);

    return (
        <FileUploaded
            pictureName={pictureName}
            setTempUrl={setTempUrl}
            inputEl={inputEl}
            formFileClass={formFileClass}
        >
            <FileUploaded.Preview>
                {previewComponent ? (
                    previewComponent(pictureUrl, inputEl)
                ) : (
                    <PreviewAsBackground
                        pictureUrl={pictureUrl}
                        inputEl={inputEl}
                        id={id}
                    />
                )}
            </FileUploaded.Preview>
        </FileUploaded>
    );
}

FileUploadedWithResetCount.defaultProps = {
    previewComponent: null,
    formFileClass: '',
    id: '',
};

FileUploadedWithResetCount.propTypes = {
    pictureName: PropTypes.string.isRequired,
    pictureVal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, //PropTypes.object is when uploading new pic.
    resetCount: PropTypes.number.isRequired,
    formFileClass: PropTypes.string,
    previewComponent: PropTypes.func,
    id: PropTypes.string,
};
export default FileUploadedWithResetCount;
